import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/purchases.svg';

export const IconPurchases = createIconComponent(Icon);
